import React from 'react'
import useTabs from '../../../hooks/useTabs'

const DropOffCard = ({ viewJob }) => {
  return (
    <>
      <div class='card'>
        <h6 class='card-header'>Documents</h6>
        <div class='card-body'>
          <>
            <div className='row g-3 drop-off-card-overlay'>
              {viewJob?.job_trip_documents
                ?.filter(i => i.type === 'DROPOFF')
                ?.map((doc, index) => (
                  <div
                    key={index}
                    className='border rounded-3 d-flex align-items-center justify-content-center overflow-hidden'
                    style={{ width: '200px', height: '200px' }}
                  >
                    <img
                      src={doc?.submitted_attachment_url}
                      alt={`Image ${index + 1}`}
                      className='img-fluid h-100 w-100 object-fit-cover'
                    />
                  </div>
                ))}
            </div>
          </>
        </div>
      </div>
    </>
  )
}

export default DropOffCard
